<HomeNavBar />
<InactivityModal />

<main class="profile-directory-page profile-directory-page-personal">
  <section class="profile-directory-toolbar">
    <div class="profile-directory-search">
      <i class="bi bi-search" aria-hidden="true"></i>
      <input
        type="text"
        class="form-control"
        placeholder="Search members"
        v-model="userSearch"
      >
      <button
        v-if="userSearch"
        type="button"
        class="profile-directory-clear d-inline-flex align-items-center justify-content-center"
        @click="clear_search"
        aria-label="Clear search"
      >
        <i class="bi bi-x-lg" aria-hidden="true"></i>
      </button>
    </div>
  </section>

  <section v-if="loading" class="profile-directory-state">
    <Loader :loading="loading" />
  </section>

  <section v-else-if="filteredUsers.length" class="profile-directory-grid">
    <article
      v-for="user in filteredUsers"
      :key="user.id"
      class="profile-directory-card"
    >
      <div class="profile-directory-card-top">
        <img
          v-if="user.profile_picture"
          :src="user.profile_picture"
          :alt="`${get_user_name(user)} profile picture`"
          class="profile-directory-avatar"
        />
        <span
          v-else
          class="profile-directory-avatar profile-directory-avatar-fallback d-inline-flex align-items-center justify-content-center"
          aria-hidden="true"
        >
          {{ get_user_initials(user) }}
        </span>

        <span class="profile-directory-status d-inline-flex align-items-center gap-1">
          <i class="bi bi-person-check-fill" aria-hidden="true"></i>
          Profile
        </span>
      </div>

      <div class="profile-directory-card-body">
        <h5 class="profile-directory-name">{{ get_user_name(user) }}</h5>
      </div>

      <button
        type="button"
        class="btn profile-directory-action"
        @click="view_profile(user)"
      >
        <span>View Profile</span>
        <i class="bi bi-arrow-right" aria-hidden="true"></i>
      </button>
    </article>
  </section>

  <section v-else class="d-flex flex-column align-items-center justify-content text-center profile-directory-empty">
    <span class="profile-directory-empty-icon d-inline-flex align-items-center justify-content-center">
      <img :src="home_feature_icons.personal_profile" alt="Personal profiles" class="profile-directory-empty-icon-image">
    </span>
    <h5>No profiles found</h5>
    <p>
      No matching member profiles are available.
    </p>
  </section>
</main>

<StickyNav />
